import { render, staticRenderFns } from "./mfa.vue?vue&type=template&id=40bbee4a&"
import script from "./mfa.vue?vue&type=script&lang=ts&"
export * from "./mfa.vue?vue&type=script&lang=ts&"
import style0 from "./mfa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports